import React from 'react'
import { Field, Form } from 'react-final-form'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'
import Button from '@material-ui/core/Button'
import { injectIntl } from 'react-intl'
import T from 'prop-types'
import getValidator, {
  VALIDATOR_CONFIRM_PASSWORD,
  VALIDATOR_IS_EMPTY,
  VALIDATOR_PASSWORD,
} from 'validation'
import Input from '../common/Form/Input'
import messages from './translate'
import './style.scss'

function PasswordDialog({
  isOpenedModal,
  onCloseModal,
  onSubmit,
  intl: { formatMessage },
  needsOldPasswordField,
}) {
  return (
    <Dialog
      open={isOpenedModal}
      onClose={onCloseModal}
      aria-labelledby="form-dialog-title"
      className="dialog-modal">
      <DialogTitle id="form-dialog-title">
        {needsOldPasswordField
          ? formatMessage(messages.changePassword)
          : formatMessage(messages.setPassword)}
      </DialogTitle>
      <DialogContent>
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine, submitError }) => (
            <form onSubmit={handleSubmit}>
              {needsOldPasswordField && (
                <Field
                  name="old_password"
                  label={formatMessage(messages.oldPassword)}
                  render={props => <Input type="password" {...props} />}
                  disabled={submitting}
                  customError={submitError}
                  validate={getValidator(VALIDATOR_IS_EMPTY)}
                />
              )}
              <Field
                name="new_password"
                label={formatMessage(messages.newPassword)}
                render={props => <Input type="password" {...props} />}
                disabled={submitting}
                validate={getValidator([
                  VALIDATOR_IS_EMPTY,
                  VALIDATOR_PASSWORD,
                ])}
              />
              <Field
                name="confirm_password"
                label={formatMessage(messages.confirmPassword)}
                render={props => <Input type="password" {...props} />}
                disabled={submitting}
                validate={getValidator([
                  VALIDATOR_IS_EMPTY,
                  VALIDATOR_PASSWORD,
                  VALIDATOR_CONFIRM_PASSWORD,
                ])}
              />
              <div className="form-group buttons">
                <Button
                  href={null}
                  type="submit"
                  disabled={submitting || pristine}
                  variant="contained"
                  color="primary"
                  className="btn-w-md">
                  {formatMessage(messages.change)}
                </Button>
              </div>
              <div className="clearfix" />
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  )
}

PasswordDialog.propTypes = {
  isOpenedModal: T.bool.isRequired,
  onCloseModal: T.func.isRequired,
  onSubmit: T.func.isRequired,
  intl: T.object.isRequired,
  needsOldPasswordField: T.bool,
}

PasswordDialog.defaultProps = {
  needsOldPasswordField: true,
}

export default injectIntl(PasswordDialog)
